<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-flex>
          <v-layout>
            <v-flex xs4>
              <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="selectedRegion"
                item-text="name"
                placeholder="Select Region"
                @change="selectRegion"
              >
              </v-select>
            </v-flex>

            <v-flex text-right>
              <v-btn @click="openNewExclusiveDialog" depressed color="primary">
                Create New Exclusive
              </v-btn>
              <v-btn
                class="ml-2"
                @click="selectRegion()"
                depressed
                color="primary"
              >
                Refresh
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between class="mt-3">
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs3 text-right v-if="selectedRegion.name !== 'All'">
              <v-select
                hide-details
                outlined
                placeholder="Filter By Status"
                dense
                v-model="selectedState"
                @change="stateSelected"
                :items="[
                  'all',
                  'active',
                  'scheduled',
                  'updated',
                  'expired',
                  'deleted',
                ]"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="exclusives"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
        no-data-text="No data available, Select a region to start"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="copyItem(item)"> mdi-content-copy </v-icon>
        </template>
        <template v-slot:item.scheduledAt="{ item }">
          <div>
            {{ iMoment(item.scheduledAt) }}
          </div>
        </template>
        <template v-slot:item.data.isUnlimited="{ item }">
          <div v-if="item.data.isUnlimited">
            Unlimited
          </div>
          <div v-else>
            {{ item.data.redeemsLeft }}
          </div>
        </template>
        <template v-slot:item.data.expiresAt="{ item }">
          <div>
            {{ iMoment(item.data.expiresAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-exclusive-dialog
      :selectedRegion="selectedRegion"
      :collection="collection"
      ref="newExclusiveDialog"
    />
    <edit-exclusive-dialog
      :selectedRegion="selectedRegion"
      :exclusiveDetail="editedItem"
      :collection="collection"
      ref="editExclusiveDialog"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewExclusiveDialog from '../components/NewExclusiveDialog';
import EditExclusiveDialog from '../components/EditExclusiveDialog.vue';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
export default {
  components: { NewExclusiveDialog, EditExclusiveDialog },
  data() {
    return {
      selectedRegion: {},
      collection: 'pipeline',
      selectedState: '',

      search: '',
      dialogDelete: false,
      itemToDelete: {
        scheduledAt: '',
        state: '',
        data: {
          backgroundColor: '',
          expiresAt: '',
          icon: {
            name: '',
            type: '',
          },
          location: {
            latitude: '',
            longitude: '',
          },
          navigate: {
            action: '',
            backgroundColor: '',
            textColor: '',
            to: '',
          },
          placement: '',

          subtitle: '',
          textColor: '',
          title: '',
        },
      },
      headers: [
        {
          text: 'Title',
          align: 'start',
          sortable: true,
          value: 'data.content',
        },
        {
          text: 'Cost',
          value: 'data.cost',
        },
        {
          text: 'Redeems',
          value: 'data.totalRedeemed',
        },
        {
          text: 'Redeems Left',
          value: 'data.isUnlimited',
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },
        { text: 'State', value: 'state' },
        { text: 'Scheduled At', value: 'scheduledAt' },
        // { text: "Region", value: "region" },

        { text: 'Expires At', value: 'data.expiresAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedItem: {
        scheduledAt: '',
        state: '',
        data: {
          content: '',
          cost: 0,
          image: {
            thumbnail: '',
            url: '',
          },
          link: {
            name: '',
            url: '',
          },
          isUnlimited: false,
          location: {
            latitude: '',
            longitude: '',
          },
          redeemsLeft: 0,
          expiresAt: '',
        },
      },
      editedIndex: -1,
      defaultItem: {
        scheduledAt: '',
        state: '',
        data: {
          content: '',
          cost: 0,
          image: {
            thumbnail: '',
            url: '',
          },
          link: {
            name: '',
            url: '',
          },
          isUnlimited: false,
          location: {
            latitude: '',
            longitude: '',
          },
          redeemsLeft: 0,
          expiresAt: '',
        },
      },
    };
  },
  computed: {
    ...mapState('$_content', ['exclusives']),
    ...mapState('$_home', ['regions']),
  },
  created() {
    // if (this.exclusives.length === 0) {
    //   this.getExclusives({
    //     type: "exclusive",
    //     collection: "pipeline",

    //     mutation: "updateExclusives",
    //   });
    // }
    if (this.regions.length === 0) {
      this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    }
  },
  methods: {
    ...mapActions({
      getExclusives: '$_content/getContent',
      getExclusivesByRegion: '$_content/getContentByRegion',
      getExclusivesByRegionByState: '$_content/getContentByRegionByState',
      deleteExclusive: '$_content/deleteContent',
      getRegions: '$_home/getContent',
    }),
    selectRegion() {
      console.log('selectedRegion: ', this.selectedRegion);
      console.log(this.selectedState);
      switch (this.selectedState) {
        case 'all':
          this.getExclusivesByRegion({
            type: 'exclusive',
            collection: this.collection,
            mutation: 'updateExclusives',
            region: this.selectedRegion,
          });
          break;
        case 'active':
          this.getExclusivesByRegionByState({
            type: 'exclusive',
            collection: this.collection,
            mutation: 'updateExclusives',
            region: this.selectedRegion,
            state: this.selectedState,
          });
          break;
        case '':
          if (this.selectedRegion.name !== 'All') {
            this.selectedState = 'active';
          }
          console.log('setting region: ', this.selectedState);
          this.getExclusivesByRegionByState({
            type: 'exclusive',
            collection: this.collection,
            mutation: 'updateExclusives',
            region: this.selectedRegion,
            state: this.selectedState,
          });
          break;
        default:
          this.getExclusivesByRegionByState({
            type: 'exclusive',
            collection: this.collection,
            mutation: 'updateExclusives',
            region: this.selectedRegion,
            state: this.selectedState,
          });
          break;
      }
    },

    stateSelected(state) {
      this.selectedState = state;
      if (Object.keys(this.selectedRegion).length === 0) {
        return;
      }

      if (this.selectedState == 'all') {
        this.getExclusivesByRegion({
          type: 'exclusive',
          collection: this.collection,
          mutation: 'updateExclusives',
          region: this.selectedRegion,
        });
      } else {
        this.getExclusivesByRegionByState({
          type: 'exclusive',
          collection: this.collection,
          mutation: 'updateExclusives',
          region: this.selectedRegion,
          state: this.selectedState,
        });
      }
    },

    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format('lll');
      } else {
        return 0;
      }
    },
    openNewExclusiveDialog() {
      this.$refs.newExclusiveDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.exclusives.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.exclusives[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editExclusiveDialog.toggleDialog(this.editedItem);
    },
    searchArr(latitude, longitude, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (
          myArray[i].latitude === latitude &&
          myArray[i].longitude === longitude
        ) {
          return myArray[i].name;
        }
      }
    },
    copyItem(item) {
      this.editedIndex = this.exclusives.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.exclusives[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editExclusiveDialog.toggleDialog(this.editedItem, 'copy');
    },
    deleteItem(item) {
      this.editedIndex = this.exclusives.indexOf(item);
      this.itemToDelete = Object.assign({}, this.exclusives[this.editedIndex]);
      this.itemToDelete.state = 'deleted';
      this.dialogDelete = true;

      // console.log(item);
    },
    deleteItemConfirm() {
      // console.log("Deleting Item: ", this.itemToDelete);

      this.deleteExclusive({
        details: this.itemToDelete,
        collection: this.collection,
        type: 'Exclusive',
      }).then(() => {
        this.dialogDelete = false;
        this.getExclusivesByRegion({
          type: 'exclusive',
          collection: this.collection,
          mutation: 'updateExclusives',
          region: this.selectedRegion,
        });
      });
    },
  },
};
</script>

<style></style>
